/**
 * @generated SignedSource<<5778ae62415fe2b990cf3ac652555268>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpcomingEventsClubQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  endDate?: string | null | undefined;
  eventTags?: ReadonlyArray<string | null | undefined> | null | undefined;
  id: string;
  memberId?: string | null | undefined;
  search?: string | null | undefined;
  startDate?: string | null | undefined;
};
export type UpcomingEventsClubQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"UpcomingEventsClub_club">;
  } | null | undefined;
};
export type UpcomingEventsClubQuery = {
  response: UpcomingEventsClubQuery$data;
  variables: UpcomingEventsClubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTags"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "dateGte",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "dateLte",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "tagIds",
    "variableName": "eventTags"
  }
],
v14 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = [
  (v16/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpcomingEventsClubQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UpcomingEventsClub_club"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpcomingEventsClubQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClubCopyOverrides",
                "kind": "LinkedField",
                "name": "copyOverrides",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NounOverride",
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "upcomingEvents",
                "args": (v13/*: any*/),
                "concreteType": "EventConnection",
                "kind": "LinkedField",
                "name": "events",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startOn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "kind": "ScalarField",
                            "name": "accessStatusForClient",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "kind": "ScalarField",
                            "name": "signUpStatusForClient",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "spotsAvailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "EventTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventTag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v17/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "tags(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "EventSessionConnection",
                            "kind": "LinkedField",
                            "name": "eventSessions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventSessionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventSession",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startAt",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endAt",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseConnection",
                                        "kind": "LinkedField",
                                        "name": "courses",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Course",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v10/*: any*/),
                                                  (v16/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseBucket",
                                                    "kind": "LinkedField",
                                                    "name": "courseBucket",
                                                    "plural": false,
                                                    "selections": (v17/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Event",
                                        "kind": "LinkedField",
                                        "name": "event",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSeries",
                                            "kind": "LinkedField",
                                            "name": "eventSeries",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Facility",
                                                "kind": "LinkedField",
                                                "name": "facility",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FacilityCopyOverrides",
                                                    "kind": "LinkedField",
                                                    "name": "copyOverrides",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "NounOverride",
                                                        "kind": "LinkedField",
                                                        "name": "course",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "singular",
                                                            "storageKey": null
                                                          },
                                                          (v11/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v10/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v10/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v10/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "eventSessions(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "concreteType": "EventSignUpWindow",
                            "kind": "LinkedField",
                            "name": "clientEligibleSignUpWindows",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "opensAt",
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSeries",
                            "kind": "LinkedField",
                            "name": "eventSeries",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "facility",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityCopyOverrides",
                                    "kind": "LinkedField",
                                    "name": "copyOverrides",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NounOverride",
                                        "kind": "LinkedField",
                                        "name": "course",
                                        "plural": false,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                      },
                                      (v16/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "publicId",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "renderingKey",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "upcomingEvents",
                "args": (v13/*: any*/),
                "filters": [
                  "dateGte",
                  "dateLte",
                  "search",
                  "tagIds"
                ],
                "handle": "connection",
                "key": "UpcomingEventsClub_upcomingEvents",
                "kind": "LinkedHandle",
                "name": "events"
              }
            ],
            "type": "Club",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b7d2dfde41e2a77a25f12d956032528",
    "id": null,
    "metadata": {},
    "name": "UpcomingEventsClubQuery",
    "operationKind": "query",
    "text": "query UpcomingEventsClubQuery(\n  $count: Int\n  $cursor: String\n  $endDate: Date\n  $eventTags: [ID]\n  $memberId: ID\n  $search: String\n  $startDate: Date\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...UpcomingEventsClub_club\n    id\n  }\n}\n\nfragment NewPatronEventCardWrapper on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  startOn\n  spotsAvailable\n  tags(first: 1000) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        startAt\n        endAt\n        displayTime\n        courses {\n          edges {\n            node {\n              id\n              name\n              courseBucket {\n                name\n                id\n              }\n            }\n          }\n        }\n        ...useEventLocationLabel_Event\n        id\n      }\n    }\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    opensAt\n    id\n  }\n  eventSeries {\n    name\n    color\n    facility {\n      copyOverrides {\n        course {\n          plural\n        }\n      }\n      department {\n        type\n        name\n        id\n      }\n      id\n    }\n    image {\n      publicId: renderingKey\n    }\n    id\n  }\n}\n\nfragment UpcomingEventsClub_club on Club {\n  copyOverrides {\n    event {\n      plural\n    }\n  }\n  upcomingEvents: events(first: $count, after: $cursor, dateGte: $startDate, dateLte: $endDate, search: $search, tagIds: $eventTags) {\n    edges {\n      node {\n        id\n        startOn\n        ...NewPatronEventCardWrapper\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment useEventLocationLabel_Event on EventSession {\n  courses {\n    edges {\n      node {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  event {\n    eventSeries {\n      facility {\n        ...useFacilityCourseNoun_facility\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7662de4a48de82265b57550b259086fc";

export default node;
